
const GrupaRada = function(DS) {
    return DS.defineResource({
        name: 'GrupaRada',
        endpoint: '/grupeRadova'
    });
};

GrupaRada.$inject = ['DS'];


export {GrupaRada};



// WEBPACK FOOTER //
// ./app/models/grupaRada.js